<template>
  <div
       id="app"
       class="">
    <loading
             :active.sync="isLoading"
             :can-cancel="false"
             :is-full-page="true" />
    <div id="wrapper">
      <nav
           class="navbar-default navbar-static-side"
           role="navigation">
        <div class="sidebar-collapse">
          <ul
              id="side-menu"
              class="nav metismenu">
            <li class="nav-header">
              <div class="dropdown profile-element">
                <span class="block m-t-xs">
                  <strong class="font-bold color-white">{{ user.name }}</strong>
                </span>
                <span class="block m-t-xs">
                  <strong class="color-white">{{ user.ldap_id }}</strong>
                </span>
                <span class="block m-t-xs">
                  <strong class="color-white">{{ userType }}</strong>
                </span>
              </div>
              <div class="logo-element">
                <i class="fa fa-user" />
              </div>
            </li>
            <router-link
                         :to="{ name: 'home' }"
                         tag="li">
              <a>
                <i class="fa fa-calendar" />
                <span class="nav-label">Activities</span>
              </a>
            </router-link>
            <template v-if="isAdmin">
              <li :class="{active: inManagePage, inactive: !inManagePage}">
                <a>
                  <i class="fa fa-wrench" />
                  <span class="nav-label">Management</span>
                  <span class="fa arrow" />
                </a>
                <ul
                    :class="{in: inManagePage}"
                    class="nav nav-second-level">
                  <li>
                    <router-link :to="{name: &quot;event-management&quot;}">Activities</router-link>
                  </li>
                  <li>
                    <router-link :to="{name: &quot;template-management&quot;}">Activity Descriptions</router-link>
                  </li>
                  <li>
                    <router-link :to="{name: &quot;previous-order-management&quot;}">Export Registrations</router-link>
                  </li>
                  <li>
                    <router-link :to="{name: &quot;user-management&quot;}">Users</router-link>
                  </li>
                  <li>
                    <router-link :to="{name: 'blacklist-management'}">Blacklists</router-link>
                  </li>
                </ul>
              </li>
            </template>
            <router-link
                         :to="{ name: 'my-events' }"
                         tag="li">
              <a>
                <i class="fa fa-user" />
                <span class="nav-label">My Activity</span>
              </a>
            </router-link>
            <router-link
                         :to="{ name: 'mailbox' }"
                         tag="li">
              <a>
                <i class="fa fa-envelope" />
                <span class="nav-label">Mailbox </span>
                <span class="label label-warning pull-right">{{ user.unread_messages }}/{{ user.total_messages }}</span>
              </a>
            </router-link>
          </ul>
        </div>
      </nav>
      <div
           id="page-wrapper"
           class="gray-bg">
        <div class="row border-bottom">
          <nav
               class="navbar navbar-static-top"
               role="navigation"
               style="margin-bottom: 0">
            <div class="navbar-header">
              <a
                 class="navbar-minimalize minimalize-styl-2 btn btn-primary"
                 href="#">
                <i class="fa fa-bars" />
              </a>
            </div>
            <ul class="nav navbar-top-links navbar-right">
              <li>
                <span class="m-r-sm text-muted welcome-message">Welcome to SALL Reservation
                </span>
                <span
                      v-if="user.blacklist"
                      class="text-danger m-r-sm"> You are now in blacklist until {{ user.blacklist_expiry_time | moment("YYYY-MM-DD") }}. </span>
              </li>
              <!-- <li>
                <router-link class="count-info" to="/mailbox">
                  <i class="fa fa-envelope"></i>
                  <span class="label label-warning">{{user.unread_messages}}</span>
                </router-link>
              </li> -->
              <li>
                <a href="/login">
                  <i class="fa fa-sign-out" />
                  <span class="navbar-login">
                    <CUHKSZOAuth
                                 class="login"
                                 @loginEvent="login"
                                 @logoutEvent="logout"
                                 @showLoading="showLoading"
                                 @hideLoading="hideLoading" />
                  </span>
                </a>
              </li>
            </ul>
          </nav>
        </div>
        <main
              role="main"
              class="">
          <router-view
                       :user="user"
                       @showLoading="showLoading"
                       @hideLoading="hideLoading"
                       @refreshUser="refreshUser" />
        </main>
        <Footer />
      </div>
    </div>
  </div>
</template>

<style scoped>
#app {
  font-family: "open sans", "Helvetica Neue", Helvetica, Arial, sans-serif;
}

b,
strong {
  font-weight: 700;
}

.color-white {
  color: white;
}

span.navbar-login .login {
  padding-left: 0 !important;
}
</style>

<style>
@media (max-width: 426px) {
  .mobile-hide {
    display: none;
  }
}
@media (min-width: 426px) {
  .mobile-show {
    display: none;
  }
}

.margin-top-10-px {
  margin-top: 10px !important;
}

.margin-top-20-px {
  margin-top: 20px !important;
}
</style>

<script>
import CUHKSZOAuth from "@/components/CUHKSZOAuth.vue";
import Footer from "@/components/footer.vue";
import Loading from "vue-loading-overlay";
import "jquery";

export default {
  name: "App",
  components: {
    CUHKSZOAuth,
    Loading,
    Footer
  },
  data () {
    return {
      user: {
        id: localStorage.getItem("userId")
      },
      isLoading: false
    };
  },
  computed: {
    isAdmin: function () {
      if (this.user.roles) {
        const len = this.user.roles.length;
        for (let j = 0; j < len; j += 1) {
          if (this.user.roles[j] === "Admin") {
            return true;
          }
        }
      }
      return false;
    },
    userType: function () {
      let u = "";
      if (this.user.roles) {
        const len = this.user.roles.length;
        for (let j = 0; j < len; j += 1) {
          if (j === 1) {
            u += ",";
          }
          u += this.user.roles[j];
        }
      }
      return u;
    },
    inManagePage: function () {
      return this.$route.path.startsWith("/manage");
    }
  },
  created () {
    this.refreshUser();
  },
  mounted () {
    this.$nextTick(() => {
      window.jQuery("#side-menu").metisMenu({
        toggle: true
      });
    });

    toastr.options = {
      closeButton: true,
      debug: false,
      progressBar: true,
      preventDuplicates: false,
      positionClass: "toast-top-right",
      onclick: null,
      showDuration: "400",
      hideDuration: "1000",
      timeOut: "3000",
      extendedTimeOut: "1000",
      showEasing: "swing",
      hideEasing: "linear",
      showMethod: "fadeIn",
      hideMethod: "fadeOut"
    };

    $(".collapse-link").on("click", function (e) {
      e.preventDefault();
      var ibox = $(this).closest("div.ibox");
      var button = $(this).find("i");
      var content = ibox.children(".ibox-content");
      content.slideToggle(200);
      button.toggleClass("fa-chevron-up").toggleClass("fa-chevron-down");
      ibox.toggleClass("").toggleClass("border-bottom");
      setTimeout(function () {
        ibox.resize();
        ibox.find("[id^=map-]").resize();
      }, 50);
    });
  },
  methods: {
    login (user) {
      this.user = user;
      const len = user.roles.length;
      for (let j = 0; j < len - 1; j += 1) {
        if (j === 1) {
          this.userType += ", ";
        }
        this.userType += this.user.roles[j];
        if (user.roles[j] === "Admin") {
          this.isAdmin = true;
        }
      }
    },
    logout () {
      this.user = {};
    },
    showLoading () {
      if (!this.isLoading) this.isLoading = true;
    },
    hideLoading () {
      if (this.isLoading) this.isLoading = false;
    },
    refreshUser () {
      const that = this;
      if (localStorage.getItem("accessToken") && this.user.name !== undefined) {
        console.info("Refreshing user info...");
        window.request.get(`user/${this.user.id}`).then(response => {
          that.user = response.data.user;
          sessionStorage.setItem("user", JSON.stringify(response.data.user));
        });
      }
    }
  },
};
</script>

<style>
@import "~fullcalendar/dist/fullcalendar.css";
@import "~vue-loading-overlay/dist/vue-loading.min.css";
@import "~@/assets/toastr.min.css";
@import "~@/assets/inspinia/css/animate.css";
@import "~@/assets/inspinia/font-awesome/css/font-awesome.css";
@import "~@/assets/inspinia/css/bootstrap.css";
@import "~@/assets/inspinia/css/style.css";
@import "~@/assets/inspinia/css/plugins/clockpicker/clockpicker.css";
@import "~@/assets/daterangepicker.css";
@import "~quill/dist/quill.core.css";
@import "~quill/dist/quill.snow.css";
@import "~quill/dist/quill.bubble.css";
</style>

<style>
.loading-overlay.is-full-page {
  z-index: 3000 !important;
}

/* homepage */
#create_event {
  padding: 2% 0 2% 0;
}

.modal-title {
  float: left;
  font-size: 20px;
}

.modal-header span {
  font-size: 30px;
}

#list-calendar {
  padding: 1.5% 0 1% 0;
  /* font-size: 40px;*/
}

.event-list {
  background: white;
  box-shadow: none;
  border: solid 1px #d1d1d1;
  color: #4a4a4a;
  font-size: 14px;
  font-weight: 400;
  cursor: pointer;
  min-height: 80px;
  text-align: center;
  padding: 10px;
  overflow: auto;
  margin-bottom: 3px;

  transition: all 0.3s ease-in-out;
  -webkit-transition: all 0.3s ease-in-out;
  -moz-transition: all 0.3s ease-in-out;
  -ms-transition: all 0.3s ease-in-out;
  -o-transition: all 0.3s ease-in-out;
}

.event-list:hover {
  box-shadow: 0 0 6px rgba(81, 203, 238, 1);
}

.event-list .col-xs-6,
.event-list .col-xs-5 {
  padding: 1.5% 1%;
  border-right: solid 1px #d1d1d1;
  height: auto;
  min-height: 50px;
  max-height: 50px;
  position: relative;
}

.event-list .col-xs-1 {
  padding: 1.5% 1%;
  height: auto;
  min-height: 50px;
  max-height: 50px;
  position: relative;
}

.hide {
  display: none;
}

/* events_info */
.reg_list {
  text-align: center;
}

#event_control {
  padding: 2% 0 1% 5%;
}

/* blacklist */
#add_blacklist {
  /* padding: 2% 1% 0 10%;*/
}

/* mailbox */
#compose_mail {
  padding: 2% 1% 0 10%;
}

#mailComposeModal .modal-content {
  width: 150%;
}

#mailDetailModal .col-sm-10 {
  padding-top: 7px;
  margin-bottom: 0;
}

#mailDetailModal .col-sm-2 {
  text-align: left;
}

.mail-text {
  padding-top: 24px;
}

.btn-disabled {
  background-color: #e6e6e6;
  border: 1px solid #d2d2d2;
}
</style>
